import { useStores } from "../../../store";
import { useEffect, useState } from "react";
import { useObserver } from "mobx-react";
import { useNavigate } from "react-router-dom";

export default function YoutubeVideo() {
  const [enableButton, setEnableButton] = useState(false);

  const navigate = useNavigate();
  const startDelay = () => {
    setTimeout(() => setEnableButton(true), 1000);
  };

  useEffect(() => {
    startDelay();
  }, []);

  const { PopupStore } = useStores();
  return useObserver(() => (
    <>
      <div className="fixed w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40">
        <div className="fixed inset-0 bg-bg3 z-50 flex flex-col justify-center rounded items-center md:w-[60%] lg:w-[60%] w-[90%] h-[95%] md:h-[70%] lg:h-[70%] m-auto shadow-lg overflow-y-auto ">
          <div className="flex flex-col justify-start overflow-y-scroll h-full  w-full border px-[10%] ">
            <AssessmentTutorial enableButton={true} />
            {enableButton ? (
              <button
                onClick={() => {
                  PopupStore.setVideoPopup(false);
                  navigate("/dashboard/myapplicants");
                }}
                className="mt-5 mx-auto bg-primary w-fit px-5 py-2 text-xl text-white rounded-lg"
              >
                Next
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </>
  ));
}
export function AssessmentTutorial() {
  const { PopupStore } = useStores();
  return (
    <>
      {/* <AiFillCloseCircle
          className="text-primary absolute text-2xl cursor-pointer top-2 right-2"
          onClick={() => PopupStore.setVideoPopup(false)}
        /> */}
      {/* iframe with onFocus to detect interaction */}
      <div className="flex flex-col justify-start w-full h-fit px-[5%] ">
        <h1 className="text-xl md:text-2xl lg:text-2xl  font-bold my-5 text-center">
          Steps for Assessment complete
        </h1>
        {/* <div className="h-fit">
        <iframe
          className="md:w-full  lg:w-full w-full md:h-[50vh] lg:h-[50vh] h-[25vh]" src="https://www.youtube.com/embed/QSRU0jpfJRg?si=_stSw1JKQcibYXhB&start=60&autoplay=1" title="YouTube video player" frameborder="0"  referrerpolicy="strict-origin-when-cross-origin"></iframe>
      </div> */}
        <p>
          <br /> <b> Step 1: </b> <br /> You'll be redirected to the Application
          section. Find the job you applied for and click on Take Assessment. 📝
          Enter the requested details and upload your resume.
          <br /> <b> Step 2: </b> <br /> You will be redirected to the Interview
          page. Allow the necessary permissions: 🎤 Microphone permission 📹
          Camera permission 🖥️ Share your entire screen Complete your interview,
          click Show My Results, and view your results. 📊
          <br /> <b> Step 3: </b> <br /> Go back to the Application section,
          select the same job, and take the next assessment. Repeat the process
          above.
        </p>
      </div>
    </>
  );
}
